import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { content: String }

  connect() {
    this.element.style.position = 'relative'
    this.element.style.cursor = 'help'

    this.tooltip = document.createElement('div')
    this.tooltip.className = 'absolute z-10 px-3 py-2 text-xs font-medium text-white bg-gray-900 rounded-lg shadow-sm invisible opacity-0 transition-all duration-150'
    this.tooltip.style.bottom = '100%'
    this.tooltip.style.left = '50%'
    this.tooltip.style.transform = 'translateX(-50%)'
    this.tooltip.style.marginBottom = '8px'
    this.tooltip.style.whiteSpace = 'nowrap'
    this.tooltip.style.maxWidth = '300px'

    const textNode = document.createTextNode(this.contentValue)
    this.tooltip.appendChild(textNode)

    const arrowWrapper = document.createElement('div')
    arrowWrapper.className = 'absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-full'
    const arrowInner = document.createElement('div')
    arrowInner.className = 'w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-gray-900'
    arrowWrapper.appendChild(arrowInner)
    this.tooltip.appendChild(arrowWrapper)

    this.element.appendChild(this.tooltip)

    // Store bound references so they can be removed later
    this._boundShow = this.show.bind(this)
    this._boundHide = this.hide.bind(this)

    this.element.addEventListener('mouseenter', this._boundShow)
    this.element.addEventListener('mouseleave', this._boundHide)
    this.element.addEventListener('focus', this._boundShow)
    this.element.addEventListener('blur', this._boundHide)
  }

  show() {
    this.tooltip.classList.remove('invisible', 'opacity-0')
    this.tooltip.classList.add('visible', 'opacity-100')
  }

  hide() {
    this.tooltip.classList.remove('visible', 'opacity-100')
    this.tooltip.classList.add('invisible', 'opacity-0')
  }

  disconnect() {
    this.element.removeEventListener('mouseenter', this._boundShow)
    this.element.removeEventListener('mouseleave', this._boundHide)
    this.element.removeEventListener('focus', this._boundShow)
    this.element.removeEventListener('blur', this._boundHide)

    if (this.tooltip) {
      this.tooltip.remove()
    }
  }
}
